<template>
  <v-container fluid fill-height class="login-container">
    <img class="login-bg" src="@/assets/slice2.jpg" alt="">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            
            <v-card class="login-form">
<div class="login-logo">
              <img src="@/assets/logo.png" alt="Vuetify.js" class="center-block">
            </div>
              <v-card-text>
                <v-form v-model="valid">

                  <v-select solo :rules="required" v-model="text17" :items="items" item-text="descripcion" item-value="id_control_oficina" label="SELECCIONE LA OFICINA" ></v-select> 
                  <v-text-field solo required :rules="required" v-model="text6" label="NOMBRE" type="text"></v-text-field> 
                  <v-text-field solo required :rules="required" v-model="text14" label="APELLIDO" type="text"></v-text-field>
                  <v-select solo :rules="required" v-model="text8" :items="documents" item-text="label" item-value="id" label="SELECCIONE EL TIPO DE IDENTIFICACION" ></v-select> 
                  <v-text-field solo required :rules="required" v-model="text7" label="NUMERO DE IDENTIFICACION" type="text"></v-text-field>
                  <v-text-field solo required :rules="emailRules" v-model="text9" label="EMAIL" type="email"></v-text-field>
                  <v-text-field solo required :rules="required" v-model="text15" label="CLAVE" type="password"></v-text-field> 
                  <v-text-field solo required :rules="passwordRules" v-model="text18" label="REPETIR CLAVE" type="password"></v-text-field> 
                  <v-select solo :rules="required" v-model="text10" :items="provincias" item-text="descripcion" item-value="id_provincia" label="SELECCIONE LA PROVINCIA" ></v-select>
                  <v-text-field solo required :rules="required" v-model="text11" label="DIRECCIÓN" type="text"></v-text-field>
                  <v-text-field solo required :rules="required" v-model="text12" label="TELEFONO" type="text"></v-text-field>
                  <v-text-field solo required  v-model="text13" label="TELEFONO" type="text"></v-text-field>

                  
                </v-form>
                

                <v-btn :disabled="!valid" block color="primary" @click="validateLogin" class="login-separador-btn">REGISTRARME</v-btn>

                <v-btn  block color="secondary" to="/">iniciar sesión</v-btn> 
              </v-card-text>
              
              
            </v-card>
          </v-flex>
        </v-layout>
      <v-snackbar
          :timeout="2000"
          v-model="snackbarLogin"
        >
        {{ snackbarLoginText }}
        <v-btn flat color="pink" @click.native="snackbarLogin = false">Close</v-btn>
      </v-snackbar>
      </v-container>
</template>

<script>
  import Helpers from '../utils/helpers'
  import Server from '../utils/server'
  import { mapState } from 'vuex';
  export default {
    created() {
      
    },
    mounted () {
      this.getPacks(); 
    },

    data: function () {
      return {
        valid: false,
        text17: '',
        text6: '',
        text14: '',
        text8: '',
        text7: '',
        text9: '',
        text15: '',
        text18: '',
        text10: '',
        text11: '',
        text12: '',
        text13: '',
        items: [],
        documents: [{id:"Cedula",label:"Cedula"}, {id:"Pasaporte",label:"Pasaporte"}, {id:"RNC",label:"RNC"}],
        provincias:[],
        required: [
          v => !!v || 'El campo es requerido'
        ],
        passwordRules:[v => v === this.text15 || 'La clave debe ser la misma.',v => !!v || "El campo es requerido"],
        emailRules: [
        v => !!v || "El campo es requerido",
        v =>
          /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(
            v
          ) || "El email debe ser valido"
      ],
        snackbarLogin: false,
        snackbarLoginText: 'El Email o la cedula  ya estan registrados.' 
      }
    },
    computed: {
      user(){
        return this.$store.getters.user;
      },
      login(){
        return this.$store.getters.login;
      },
      profile: function(){
        return this.$store.getters.profile
      }
    },
    methods: {
      validateLogin: function () {
        const _this = this

        // this.$store.dispatch('login', true)
        // this.$router.push('packages')

        var formData = new FormData()
        formData.append('text17', this.text17)
        formData.append('text6', this.text6)
        formData.append('text14', this.text14)
        formData.append('text8', this.text8)
        formData.append('text7', this.text7)
        formData.append('text9', this.text9)
        formData.append('text15', this.text15)
        formData.append('text18', this.text18)
        formData.append('text10', this.text10)
        formData.append('text11', this.text11)
        formData.append('text12', this.text12)
        formData.append('text13', this.text13)
        formData.append('device', window.MobileApi.device)

        this.$http.post(Server.registro, formData) 
          .then( 
            response => {
              console.log(response)
              if (response.body[0].id_cliente !== undefined) { 
                this.$store.dispatch('login', true)
                this.$router.push('profile') 
                window.MobileApi.setSessionId(response.body[0].id_cliente);   
              } else {
                this.snackbarLogin = true
              }
            },
            () => {
              this.error = true;
              this.msj = "Ha ocurrido un error inténtelo  más tarde";
            }
          );

        // Helpers.getJson(Server.login, 'POST', formData, function (json) {
        //   console.log(json.resultado)
        //   if (json.resultado > 0) {
        //     _this.$store.dispatch('login', true)
        //     _this.$router.push('packages')
        //   } else {
        //     _this.snackbarLogin = true
        //   }
        // })
      },
    getPacks(){
      var formData = new FormData()
        formData.append('text1', 0) 
        formData.append('text3', 0)
        formData.append('device', window.MobileApi.device)
        console.log("yes"); 
      this.$http.post(Server.oficinas, formData)  
          .then( 
            response => {
              if(response.body.resultado !=="NO" || response.body.resultado == null || response.body.resultado == undefined){
                this.items = response.body
              }else{
                this.items = [] 
              }
              
            },
            () => {
              this.error = true;
              this.msj = "Try again later";
            }
          );
          this.$http.post(Server.provincias, formData)  
          .then( 
            response => {
              if(response.body.resultado !=="NO" || response.body.resultado == null || response.body.resultado == undefined){
                this.provincias = response.body
              }else{
                this.items = []
              }
              
            },
            () => {
              this.error = true;
              this.msj = "Try again later";
            }
          );
    }
    }
  }
</script>

<style lang="sass" scoped>  
  @import "../assets/css/login.scss" 
</style> 